<template>
	<v-dialog v-model="display" max-width="290" persistent>
		<v-card>
			<v-card-title class="headline">アルバムの削除</v-card-title>
			<v-card-text>
				アルバムの写真がすべて削除され、元に戻すことはできません。<br>
				よろしいでしょうか。
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn flat @click="$emit('click-cancel')">キャンセル</v-btn>
					<v-btn flat color="red darken-1" @click="$emit('click-confirm')">削除</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'DialogConfirmDeletePhotoAlbum',
	props: [ 'display' ],
};
</script>
